import React, {useContext,useEffect} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useHelper } from '../hooks/useHelper';
export const Dialogos = ({open,
                          procesarResultado,
                          titulo,
                          children,
                          texto,
                          procesarCancelar,
                          error,
                          textoAceptar,
                          textoCancelar,
                          fullscreen,
                          closeHeader,
                          style,
                          backdropProps,
                          soloCheckCerrar,
                          contentStyle})=>{
    const {datos,handleChangeCarrera} = useContext(formularioContext)
    const {scrollTop} = useHelper()

    useEffect(()=>{
      scrollTop();
    },[])

    return     <div>
    <Dialog style={style} fullScreen={fullscreen || false} open={open} onClose={procesarResultado}
    >
      {titulo && <DialogTitle style={{background:'rgb(232 240 254)'}} >{titulo}
          {closeHeader && <Button style={{width:'100%',justifyContent:'center'}} title='Cerrar' onClick={procesarCancelar}>Cerrar </Button>}
      </DialogTitle>}
      <DialogContent style={contentStyle}>
        <DialogContentText>
            {texto}
        </DialogContentText>
        {children}
        {error && <p style={{color:'red'}}>{error}</p>}
      </DialogContent>
      <DialogActions>
        {soloCheckCerrar && procesarCancelar && <Button title='Cerrar' onClick={procesarCancelar}></Button>}
        {procesarCancelar && !soloCheckCerrar && <Button variant="outlined" onClick={procesarCancelar}>{textoCancelar || 'Cancelar'}</Button>}
        {procesarResultado && <Button variant="contained" color='primary' onClick={procesarResultado}>{textoAceptar ? textoAceptar : 'Aceptar'}</Button>}
      </DialogActions>
    </Dialog>
  </div>
}